import * as actionTypes from './actionTypes';
import { typePropertyService } from './services';
import { actionsModalError } from '@app/src/common/modalError';
import { fetchValidateAccess } from '@app/src/common/session';

const fetchTypePropertyRequest = () => ({
  type: actionTypes.FETCH_TYPE_PROPERTY_REQUEST
});

const fetchTypePropertySuccess = (data) => ({
  type: actionTypes.FETCH_TYPE_PROPERTY_SUCCESS,
  data
});

const fetchTypePropertyFailure = () => ({
  type: actionTypes.FETCH_TYPE_PROPERTY_FAILURE
});

export const fetchTypeProperty = (operationId: number, packageId?: number): Function => {
  return async dispatch => {
    dispatch(fetchTypePropertyRequest());
    try {
      let data = null;

      if (packageId) {
        data = await typePropertyService.getConsume(operationId, packageId);
      } else {
        await dispatch(fetchValidateAccess());
        data = await typePropertyService.get(operationId);
      }
      dispatch(fetchTypePropertySuccess(data));
    } catch (e) {
      dispatch(fetchTypePropertyFailure());
      dispatch(actionsModalError.openModalError());
    }
  }
};
